// cart-drawer.js  ✅ robust against load order + missing overlay
(() => {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));

      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLinks = document.querySelectorAll('#cart-icon-bubble');
      if (!cartLinks.length) return;

      cartLinks.forEach((cartLink) => {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');

        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });

        cartLink.addEventListener('keydown', (event) => {
          if (event.code && event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

      setTimeout(() => this.classList.add('animate', 'active'));

      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling?.id) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget.closest('details').hasAttribute('open')
        );
      });

      if (typeof onKeyUpEscape === 'function') {
        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
      }
    }

    renderContents(parsedState) {
      const inner = this.querySelector('.drawer__inner');
      if (inner?.classList.contains('is-empty')) inner.classList.remove('is-empty');

      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [{ id: 'cart-drawer', selector: '#CartDrawer' }];
    }

    setActiveElement(el) { this.activeElement = el; }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

function defineCartDrawerItems() {
  // Wait until CartItems is actually present on window
  if (!window.CartItems) return false;
  if (customElements.get('cart-drawer-items')) return true;

  class CartDrawerItems extends window.CartItems {
    getSectionsToRender() {
      return [
        // Replace the drawer’s inner contents from the cart-drawer section
        {
          id: 'CartDrawer',           // DOM id in your Liquid
          section: 'cart-drawer',     // Shopify section_id to request
          selector: '.drawer__inner'  // inside #CartDrawer to swap
        },
        // Update the header/cart count bubble
        {
          id: 'cart-count-bubble',
          section: 'cart-count-bubble',
          selector: '.shopify-section'
        }
        // If you also need live region text, uncomment this:
        // {
        //   id: 'cart-live-region-text',
        //   section: 'cart-live-region-text',
        //   selector: '.shopify-section'
        // }
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
  return true;
}

// Try now; if not ready, wait for cart.js to announce it's ready
if (!defineCartDrawerItems()) {
  window.addEventListener('CartItems:ready', defineCartDrawerItems, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => defineCartDrawerItems(), { once: true });
  } else {
    setTimeout(() => defineCartDrawerItems(), 0);
  }
}

})();
